<template>
    <div class="deal_index_box">
        <!-- 交易帳單 -->
        <div class="deal_title">
            <div>帳單管理<span>》</span>交易帳單</div>
            <div class="deal_hr">
                <div class="cut_off"></div>
            </div>
        </div>
        <!-- 内容 -->
        <div class="deal_content_box">
            <div class="deal_content_title">交易帳單</div>
            <div class="deal_content">
                <div class="center_box">
                    <!-- 交易帳單 -->
                    <!-- <div class="time_box">每天上午10：00前完成資料更新，目前資料更新至<span>{{time}}</span></div> -->
                    <el-form ref="form" :model="form" label-width="100px">
                        <el-form-item label="對帳單類型：" class="money_box">
                            <el-radio v-model="radio" label="0">所有交易帳單(不含可用餘額退款)</el-radio>
                            <!-- <el-radio v-model="radio" label="1">支付帳單</el-radio> -->
                            <!-- <el-radio v-model="radio" label="3">退款帳單(不含可用餘額退款)</el-radio>
                            <el-radio v-model="radio" label="4">可用餘額退款對帳單</el-radio> -->
                        </el-form-item> 
                        <el-form-item label="對帳單日期：">
                            <el-date-picker
                                v-model="dateValue"
                                type="daterange"
                                align="center" 
                                value-format="timestamp"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="開始日期"
                                end-placeholder="結束日期"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                            <span class="deal_content_span">查詢期日不可超過31天</span>
                        </el-form-item>
                    </el-form>
                    <!-- 查詢按钮 -->
                    <div class="inquire_button">
                        <el-radio v-model="buttonRadio" label="exportexcel"><img src="../../../../assets/img/login/logindeal/icon_xls.png" alt=""></el-radio>
                        <el-radio v-model="buttonRadio" label="exporttxt"><img src="../../../../assets/img/login/logindeal/icon_txt.png" alt=""></el-radio>
                        <el-button type="primary" @click="ExcelFun()">匯出對帳單</el-button> 
                    </div>
                    <div>
                    </div>
                </div>
            </div>
        </div>
        <!-- deal_index_box -->
    </div>
</template>

<script>
export default {
    name: 'LoginDealBills',
    data() {
        return {
            form:{
            },
            radio: '0',
            buttonRadio: 'exportexcel',
            // 日期
            pickerOptions: {
                shortcuts: [{
                    text: '最近一週',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一個月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            time:'2019-03-29',
            dateValue: '',
            paymentValue: '',
            transactionValue: '',
        // return
        }
    },
    methods: {
        handleClick(tab, event) {
            // console.log(tab, event);
      },
       handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
      },
      // FUN-EXCEL下載
        ExcelFun(){
            let txt_url = '';
            let charset = '';
            
            // 简体还是繁体
            if (navigator.language === "zh-TW"){
                charset = "BIG5";
            } else {
                charset = "GBK";
            }

            if(this.dateValue != ''){
                let time31 = this.dateValue[1] - 3600 * 1000 * 24 * 31;

                this.end_time = this.dateValue[1].toString();

                this.start_time = this.dateValue[0].toString();

                // 是否小于31：
                if(this.start_time < time31){
                    // console.log('大于31天')
                    this.$message({
                    showClose: true,
                    message: '查詢期日不可超過31天',
                    type: 'error',
                    duration: 1000
                    });
                    return
                } else {
                    // console.log('小于等于31天')
                    this.end_time = this.end_time.substring(0, 10);
                    this.start_time = this.start_time.substring(0, 10);
                }

            // 下载：
            txt_url = this.$store.state.axiosbillsUrl
                +'&uid='+this.$store.state.uid
                +'&end_time='+this.end_time
                +'&start_time='+this.start_time
                +'&status='+this.radio
                +'&charset='+charset
                +'&do='+this.buttonRadio;
            } else {

            // 下载：
            // txt_url = this.$store.state.axiosbillsUrl
            //     +'&uid='+this.$store.state.uid
            //     +'&status='+this.radio
            //     +'&charset='+charset
            //     +'&do='+this.buttonRadio;

            this.$message({
            showClose: true,
            message: '對帳單日期不能為空',
            type: 'error',
            duration: 1000
            });
            return

            }



            window.location.href = txt_url;
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 交易管理》交易订单 */
    .deal_index_box {
        margin: 20px;
        font-size: 15px;
        color: black;
    }
    .deal_title {
        margin: 30px 0;
        display: flex;
        justify-content: flex-start;
    }
    .deal_title span {
        margin-left: 15px;
        margin-right: 8px;
    }
    .deal_title .deal_hr {
        flex: 1;
        margin-left: 18px;
    }
    .deal_title .deal_hr .cut_off {
        height: 3px;
        background: black;
        margin-top: 8px;
    }
/* 内容 */
    .time_box {
        font-size: 17px;
        margin-bottom: 33px;
        letter-spacing: 1px;
    }
    .time_box > span {
        color: #e73262;
        margin: 0 5px;
    }
    .datetime_box > span {
        margin: 10px;
    }
    .deal_content_box {
        font-size: 13px;
        margin-top: 20px;
    }
    .deal_content_title {
        height: 42px;
        background: #666666;
        line-height: 42px;
        color: white;
        padding-left: 14px;
    }
    .deal_content {
        box-sizing: border-box;
        /* height: 53.6vw; */
        min-height: 500px;
        border: 1px solid #666666;
        background: #ffffff;
        padding: 38px 20px;
        padding-top: 26px;
    }
    .center_box {
        width: 900px;
        margin: 10px 65px;
    }
    .deal_content_span {
        margin-left: 23px;
        font-size: 11px;
        color: #e73262;
    }
    .deal_content_tab_first {
        width: 960px;
    }
    .deal_content_tab_first > div {
        margin: 14px 0;
    }
    .money_box span {
        margin: 0 10px;
    }
    .money_input {
        width: 140px;
        /* margin-left: 4px; */
    }
    .money_input01 {
        margin-left: 4px;
    }
    .inquire_button {
        padding: 10px;
    }
    /* 表单 */
    .table_download {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 6px 0;
    }
    .table_download_button {
        padding: 6px 10px;
    }
    .table_download span {
        display: inline-block;
        margin: 0 10px;
    }
    /* 表单头 */
    .table_header {
        height: 36px;
        line-height: 36px;
        background: #f2f2f2;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
    .table_content {
        padding: 10px 0;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
     .table_date {
        box-sizing: border-box;
        width: 100px;
        padding-left: 14px;
        padding-right: 10px;
    }
    .table_merchantorder {
        box-sizing: border-box;
        word-break: break-all;
        word-wrap: break-word;
        width: 200px;
        padding: 0 10px;
        min-width: 160px;
    }
    .table_paymentorder {
        box-sizing: border-box;
        word-break: break-all;
        word-wrap: break-word;
        width: 200px;
        min-width: 160px;
        padding: 0 10px;
        min-width: 160px;
    }
    .table_paymenttype {
        box-sizing: border-box;
        width: 98px;
        padding: 0 10px;
        min-width: 77px;
    }
    .table_status {
        box-sizing: border-box;
        width: 100px;
        padding: 0 10px;
    }
    .table_money {
        box-sizing: border-box;
        width: 110px;
        padding: 0 10px;
    }
    .table_charge {
        box-sizing: border-box;
        width: 80px;
        padding: 0 10px;  
    }
    .table_draw {
        box-sizing: border-box;
        width: 90px;
        padding: 0 10px;
    }
    .table_name {
        box-sizing: border-box;
        width: 140px;
        padding: 0 10px;
    }
    .table_operation {
        padding: 0 10px;
    }
    .table_operation > span {
        margin-right: 10px;
    }
    .table_operation > span > span {
        margin-right: 2px;
        padding-bottom: 2px;
        border-bottom: 1px solid;
    }
/* 分页 */
    .table_pagination {
        display: flex;
        margin: 20px;
        justify-content: flex-end;
    }
    .annotation {
        font-size: 11px;
        color: #777;
    }
    .annotation > p {
        line-height: 17px;
        margin-left: 18px;
    }
    .annotation .annotation_p {
        margin: 0px;
        margin-top: 10px;
    }
    .annotation .annotation_span {
        border-bottom: 1px solid #326ede;
        color: #326ede;
    }
</style>
